import React from "react";
import './index.css';
import Group, {GroupTabContent} from "../../Components/Group";
import moment from "jalali-moment";
import MDashboard from "../../Server/MDashboard";
import Date from "../../Components/Control/Date";
import LabelValueTable from "../LabelValueTable";
import Select from "../../Components/Control/Select";
import {connect} from "react-redux";
import Notif from "../../Components/Notif";
import Resource from "../../Resource";
import ModalHospitalInventoryList from "../Modal/ModalHospitalInventoryList";
import Grid, {gridDateTime, GridState, GridStates} from "../../Components/Grid";
import Perms from '../../Perms';
import MyComponent from '../../Components/MyComponent';
import {Bar, Doughnut, Line, Pie, Polar, Radar} from "react-chartjs-2";
import ModalInjectionMonitoring from "../Modal/ModalInjectionMonitoring";

// defaults.global.defaultFontFamily = 'farsi';

class ManagementDashboard extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        if (!Perms().DASHBOARD.SHOW_MINISTRY) {
            props.history.push(Resource.ROUTE.HOME);
        }

        const colors = ['#e76f51', '#f4a261', '#e9c46a', '#2a9d8f', '#264653', '#3d5a80', '#98c1d9'];
        const transparentColors = ['rgba(231,111,81,0.5)', 'rgba(244,162,97,0.5)', 'rgba(233,196,106,0.5)', 'rgba(42,157,143,0.5)', 'rgba(38,70,83,0.5)', 'rgba(61,90,128,0.5)', 'rgba(152,193,217,0.5)'];

        this.state = {
            searchProductsGrid: {
                columnDefs: [{
                    field: 'hospitalStr',
                    headerName: 'نام بیمارستان',
                    headerTooltip: 'نام بیمارستان',
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: props.base.allHospitals.map(item => item.fullName)
                    }
                }, {
                    field: 'productNumber',
                    headerName: 'شماره فرآورد',
                    headerTooltip: 'شماره فرآورد',
                    checkboxSelection: true,
                    // headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده',
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: props.base.productTypes.map(item => item.name)
                    }
                }, {
                    field: 'bloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    headerTooltip: 'BGRh فرآورده',
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: props.base.bloodGroups.map(item => item.name)
                    }
                }, {
                    field: 'productExpireDate',
                    headerName: 'تاریخ انقضا فرآورده',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    filter: 'agDateColumnFilter'
                }, {
                    field: 'productStatusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    filter: false
                }],
                rowModelType: 'serverSide',
                pagination: true,
                // paginationPageSize:10
                paginationAutoPageSize: true,
                frameworkComponents: {}
            },
            basicStatisticsGrid: {
                columnDefs: [{
                    field: 'hospitalFullName',
                    headerName: 'نام بیمارستان',
                    headerTooltip: 'نام بیمارستان',
                    filter: 'agSetColumnFilter'
                }, {
                    field: 'totalInventory',
                    headerName: 'کل',
                    headerTooltip: 'موجودی کل',
                    cellRenderer: 'totalInventoryState',
                    filter: false
                }, {
                    field: 'totalConsumableProducts',
                    headerName: 'مصرفی',
                    headerTooltip: 'مجموع فرآورده‌های مصرفی',
                    cellRenderer: row => row.data.totalConsumableProducts || '-',
                    filter: false
                }, {
                    field: 'totalReadyProducts',
                    headerName: 'آماده',
                    headerTooltip: 'فرآورده‌های آماده',
                    cellRenderer: row => row.data.totalReadyProducts || '-',
                    filter: false
                }, {
                    field: 'totalReservedProducts',
                    headerName: 'رزرو شده',
                    headerTooltip: 'فرآورده‌های رزرو شده',
                    cellRenderer: row => row.data.totalReservedProducts || '-',
                    filter: false
                }, {
                    field: 'entryProducts',
                    headerName: 'ورودی',
                    headerTooltip: 'فرآورده‌های ورودی',
                    cellRenderer: 'entryProductsState',
                    filter: false
                }, {
                    field: 'complicateProducts',
                    headerName: 'عارضه داده',
                    headerTooltip: 'فرآورده‌های عارضه داده',
                    cellRenderer: 'complicateProductsState',
                    filter: false
                }, {
                    field: 'returnToBloodBankProducts',
                    headerName: 'عودتی بخش',
                    headerTooltip: 'فرآورده‌های عودتی بخش',
                    cellRenderer: 'returnToBloodBankProductsState',
                    filter: false
                }, {
                    field: 'returnToOrgProducts',
                    headerName: 'عودتی بیمارستان',
                    headerTooltip: 'فرآورده‌های عودتی بیمارستان',
                    cellRenderer: 'returnToOrgProductsState',
                    filter: false
                }, {
                    field: 'destroyedProducts',
                    headerName: 'امحا شده',
                    headerTooltip: 'فرآورده‌های امحا شده',
                    cellRenderer: row => row.data.destroyedProducts || '-',
                    filter: false
                }],
                frameworkComponents: {
                    totalInventoryState: row => {
                        const inventory = (row.data.entryProducts || 0) - (row.data.totalConsumableProducts || 0);
                        return <GridStates>
                            {row.data.totalInventory || '-'}&nbsp;
                            {inventory > 0 && <GridState theme={'green'}><span className={'arrow-top'}>&#x279C;</span> {inventory}</GridState>}
                            {inventory < 0 && <GridState theme={'red'}><span className={'arrow-bot'}>&#x279C;</span> {Math.abs(inventory)}</GridState>}
                        </GridStates>;
                    },
                    entryProductsState: row => {
                        const diff = (row.data.entryProducts || 0) - (row.data.totalConsumableProducts || 0);
                        return <GridStates>
                            {row.data.entryProducts || '-'}&nbsp;
                            {diff > 0 && <GridState theme={'green'}><span className={'arrow-top'}>&#x279C;</span> {diff}</GridState>}
                            {diff < 0 && <GridState theme={'red'}><span className={'arrow-bot'}>&#x279C;</span> {Math.abs(diff)}</GridState>}
                        </GridStates>;
                    },
                    complicateProductsState: row => {
                        const percentage = Math.round((row.data.complicateProducts || 0) / (row.data.totalConsumableProducts || 0) * 100);
                        return <GridStates>
                            {row.data.complicateProducts || '-'}&nbsp;
                            {percentage > 0 && <GridState theme={'red'}>% {percentage}</GridState>}
                        </GridStates>;
                    },
                    returnToBloodBankProductsState: row => {
                        const percentage = Math.round((row.data.returnToBloodBankProducts || 0) / (row.data.totalConsumableProducts || 0) * 100);
                        return <GridStates>
                            {row.data.returnToBloodBankProducts || '-'}&nbsp;
                            {percentage > 0 && <GridState theme={'red'}>% {percentage}</GridState>}
                        </GridStates>;
                    },
                    returnToOrgProductsState: row => {
                        const percentage = Math.round((row.data.returnToOrgProducts || 0) / (row.data.entryProducts || 0) * 100);
                        return <GridStates>
                            {row.data.returnToOrgProducts || '-'}&nbsp;
                            {percentage > 0 && <GridState theme={'red'}>% {percentage}</GridState>}
                        </GridStates>;
                    }
                }
            },
            basicStatisticsGridContext: null,
            searchProductRowData: [],
            searchProductsGridContext: null,
            tabs: [
                {id: 'searchProduct', title: 'جستجو فرآورده'},
                {id: 'total', title: 'آمار کلی'},
                {id: 'hospitalInventory', title: 'آمار بیمارستان'},
                {id: 'hospitalInventoryDayDetail', title: 'آمار به تفکیک روز'}
            ],
            hospitals: [
                {id: '', text: '...'},
                ...this.props.base.allHospitals.map(item => {
                    return {id: item.id, text: item.fullName};
                })
            ],
            productStates: [
                {id: '', text: '...'},
                {id: 'Entery', text: 'ورودی'},
                {id: 'Consumption', text: 'مصرفی'},
                {id: 'Reserved', text: 'رزرو شده'},
                {id: 'Reserve', text: 'رزرو در حال حاضر'},
                {id: 'CrossMatched', text: 'کراسمچ شده'},
                {id: 'Ready', text: 'آماده در حال حاضر'}
            ],
            basicStatistics: [],
            basicStatisticsTable: {},
            basicInventoryChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            basicReservedChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }],
                options: {
                    legend: {
                        labels: {
                            fontFamily: 'farsi'
                        }
                    }
                }
            },
            basicReadyChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            basicConsumableChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            basicReturnToOrgChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            basicReturnToBankChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            basicEntryChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            basicDestroyedChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: colors,
                    hoverBackgroundColor: colors
                }]
            },
            hospitalProductBaseInventoryChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: '#2a9d8f',
                    hoverBackgroundColor: '#2a9d8f'
                }]
            },
            hospitalBloodBaseInventoryChart: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: '#3d5a80',
                    hoverBackgroundColor: '#3d5a80'
                }]
            },
            hospitalInventoryTable: {
                raw: [],
                bloodGroups: [],
                productTypes: [],
                bloodGroupList: [],
                productTypeList: []
            },
            inventoryDayDetailChart: {
                options: {
                    legend: {
                        labels: {
                            // This more specific font property overrides the global property
                            fontFamily: "'farsi'"
                        }
                    },
                    defaultFontFamily: "'farsi'",
                },
                labels: [],
                datasets: [{
                    label: 'فرآورده‌های ورودی',
                    data: [],
                    borderColor: '#2a9d8f',
                    fill: false,
                    hoverBackgroundColor: '#2a9d8f'
                }, {
                    label: 'فرآورده‌های مصرفی',
                    data: [],
                    borderColor: '#e9c46a',
                    fill: false,
                    hoverBackgroundColor: '#e9c46a'
                }, {
                    label: 'فرآورده‌های کراسمچ شده',
                    data: [],
                    borderColor: '#3d5a80',
                    fill: false,
                    hoverBackgroundColor: '#3d5a80'
                }, {
                    label: 'فرآورده‌های رزرو شده',
                    data: [],
                    borderColor: '#264653',
                    fill: false,
                    hoverBackgroundColor: '#264653'
                }, {
                    label: 'فرآورده‌های عارضه داده',
                    data: [],
                    borderColor: '#e76f51',
                    fill: false,
                    hoverBackgroundColor: '#e76f51'
                }]
            },
            productDayDetailChart1: {
                labels: [],
                datasets: []
            },
            productDayDetailChart2: {
                labels: [],
                datasets: []
            },
            productBloodGroupDayDetailChart1: {
                labels: [],
                datasets: [{
                    data: [],
                    borderColor: colors,
                    backgroundColor: transparentColors,
                }]
            },
            productBloodGroupDayDetailChart2: {
                labels: [],
                datasets: []
            },
            productTypeDayDetailChart1: {
                labels: [],
                datasets: [{
                    data: [],
                    borderColor: colors,
                    backgroundColor: transparentColors,
                }]
            },
            productTypeDayDetailChart2: {
                labels: [],
                datasets: [{
                    data: [],
                    borderColor: colors,
                    backgroundColor: transparentColors,
                }]
            },
            productSignChart: {
                labels: [],
                datasets: [{
                    data: [],
                    borderColor: colors,
                    backgroundColor: colors,
                }]
            },
            fields: {
                startDate: moment().startOf('jmonth'),
                endDate: moment().endOf('jday')
            },
            colors,
            transparentColors
        };

        this.ref = {
            modalHospitalInventoryList: React.createRef()
        };
    }

    componentDidMount() {
        if (true || this.Perms().SHOW_BLOOD_BANK_INVENTORY) {
            this.updateBasicCharts();
        }
    }

    render() {
        const {state} = this;
        const bloodGroups = [{id: '', text: '...', list: []},
            ...state.hospitalInventoryTable.bloodGroups.map((item, index) => {
                const bloodGroupList = state.hospitalInventoryTable.bloodGroupList[index];
                return {id: item.id, text: item.name, list: bloodGroupList};
            })
        ];
        const productTypes = [{id: '', text: '...', list: []},
            ...state.hospitalInventoryTable.productTypes.map((item, index) => {
                const productTypeList = state.hospitalInventoryTable.productTypeList[index];
                return {id: item.id, text: item.name, list: productTypeList};
            })
        ];

        const hospitalProductBaseInventoryChart = state.hospitalProductBaseInventoryChart;
        hospitalProductBaseInventoryChart.labels = [];
        hospitalProductBaseInventoryChart.datasets[0].data = [];
        hospitalProductBaseInventoryChart.datasets[0].label = (state.fields?.productTypeId || [])[0]?.text || '';
        for (let item of (state.fields?.productTypeId || [])[0]?.list || []) {
            hospitalProductBaseInventoryChart.labels.push(item.bloodGroupShortNameStr);
            hospitalProductBaseInventoryChart.datasets[0].data.push(item.inventory);
        }

        const hospitalBloodBaseInventoryChart = state.hospitalBloodBaseInventoryChart;
        hospitalBloodBaseInventoryChart.labels = [];
        hospitalBloodBaseInventoryChart.datasets[0].data = [];
        hospitalBloodBaseInventoryChart.datasets[0].label = (state.fields?.bloodGroupId || [])[0]?.text || '';
        for (let item of (state.fields?.bloodGroupId || [])[0]?.list || []) {
            hospitalBloodBaseInventoryChart.labels.push(item.productTypeShortNameStr);
            hospitalBloodBaseInventoryChart.datasets[0].data.push(item.inventory);
        }

        return <Group className={'ManagementDashboard-group mar-10'} defaultTab={'total'} tabs={state.tabs} onTabChange={this.tabChangeHandler.bind(this)}>
            <GroupTabContent id={'searchProduct'}>
                <Grid id={'searchProductsGrid'} {...this.state.searchProductsGrid} onGridReady={this.searchProductsGridReadyHandler.bind(this)}/>
            </GroupTabContent>
            <GroupTabContent id={'total'}>
                <div className="dis-f">
                    <div className={'fb-20 dis-f'}>
                        <Date className={'fb-4 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={'از تاریخ'} value={state.fields?.startDate} onChange={this.setField.bind(this, 'startDate')}/>
                        <Date className={'fb-4 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={`تا تاریخ`} value={state.fields?.endDate} onChange={this.setField.bind(this, 'endDate')}/>
                    </div>
                    <div className="fb-20 dis-f" style={{minHeight: 'calc(100vh - 200px)'}}>
                        <Grid id={'basicStatisticsGrid'} {...this.state.basicStatisticsGrid} rowData={this.state.basicStatistics} onGridReady={this.basicStatisticsGridReadyHandler.bind(this)}/>
                    </div>
                    <div className="charts dis-f">
                        <LabelValueTable {...state.basicStatisticsTable} />
                        <div className={`doughnut-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicInventoryChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'TOTAL_INVENTORY'}>موجودی بیمارستان‌ها</h3>
                            <Doughnut data={state.basicInventoryChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicReservedChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'TOTAL_RESERVED_PRODUCTS'}>فرآروده‌های رزرو شده بیمارستان‌ها</h3>
                            <Doughnut data={state.basicReservedChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-6 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicReadyChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'TOTAL_READY_PRODUCTS'}>فرآورده‌های آماده بیمارستان‌ها</h3>
                            <Doughnut data={state.basicReadyChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicConsumableChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'BASIC_CONSUMABLE_CHART'}>فرآورده‌های قابل استفاده بیمارستان‌ها</h3>
                            <Doughnut data={state.basicConsumableChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicReturnToOrgChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'RETURN_TO_ORG_PRODUCTS'}>فرآورده‌های عودتی بیمارستان‌ها</h3>
                            <Doughnut data={state.basicReturnToOrgChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-6 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicReturnToBankChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'RETURN_TO_BANK_PRODUCTS'}>فرآورده‌های عودتی بخش‌ها بیمارستان</h3>
                            <Doughnut data={state.basicReturnToBankChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicEntryChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'TOTDAL_ENTRY_PRODUCTS'}>فرآورده‌های ورودی بانک خون بیمارستان‌ها</h3>
                            <Doughnut data={state.basicEntryChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                        <div className={`doughnut-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.basicDestroyedChart.labels.length ? '' : 'background'}`}>
                            <h3 className={'chart-title'} title={'DESTROYED_PRODUCTS'}>فرآورده‌های امحا شده بیمارستان‌ها</h3>
                            <Doughnut data={state.basicDestroyedChart}
                                      width={'100%'}
                                      height={'100%'}/>
                        </div>
                    </div>
                </div>
            </GroupTabContent>
            <GroupTabContent id={'hospitalInventory'}>
                <div className={'dis-f'}>
                    <Select className={'fb-5 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={'نام بیمارستان'} options={state.hospitals} value={state.fields?.hospitalId} onChange={this.setField.bind(this, 'hospitalId')}/>
                </div>
                {state.hospitalInventoryTable?.rows?.length ? <LabelValueTable {...this.state.hospitalInventoryTable} maximizable={false} onClick={this.labelValueTableCellClickHandler.bind(this)}/> : null}
                <div className={'dis-f'}>
                    <div className="fb-10 fb-6x-20 pad-e-4 pad-6x-e-0 dis-f">
                        <div className="fb-20 dis-f">
                            <Select className={'fb-10 fb-6x-5 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={'نوع فرآورده'} options={productTypes} value={state.fields?.productTypeId} onChange={this.setField.bind(this, 'productTypeId')}/>
                        </div>
                        <div className="charts fb-20">
                            <div className={`bar-chart fb-20 ${state.hospitalProductBaseInventoryChart.labels.length ? '' : 'background'}`}>
                                <h3 className={'chart-title'} title={'TOTAL_INVENTORY'}>موجودی فرآورده بیمارستان</h3>
                                <Bar data={state.hospitalProductBaseInventoryChart}
                                     width={'100%'}
                                     height={'50%'}/>
                            </div>
                        </div>
                    </div>
                    <div className="fb-10 fb-6x-20 pad-s-4 pad-6x-s-0 dis-f">
                        <div className="fb-20 dis-f">
                            <Select className={'fb-10 fb-6x-5 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={'نوع گروه خونی'} options={bloodGroups} value={state.fields?.bloodGroupId} onChange={this.setField.bind(this, 'bloodGroupId')}/>
                        </div>
                        <div className="charts fb-20">
                            <div className={`bar-chart fb-20 ${state.hospitalBloodBaseInventoryChart.labels.length ? '' : 'background'}`}>
                                <h3 className={'chart-title'} title={'TOTAL_INVENTORY'}>موجودی فرآورده بیمارستان</h3>
                                <Bar data={state.hospitalBloodBaseInventoryChart}
                                     width={'100%'}
                                     height={'50%'}/>
                            </div>
                        </div>
                    </div>
                </div>
            </GroupTabContent>
            <GroupTabContent id={'hospitalInventoryDayDetail'}>
                <div className={'dis-f'}>
                    <Select className={'fb-5 fb-5x-8 fb-4x-10 fb-3x-20 fb-2x-20 pad-4'} label={'نام بیمارستان'} options={state.hospitals} value={state.fields?.hospitalId} onChange={this.setField.bind(this, 'hospitalId')}/>
                    <div className={'fb-4x-10 fb-3x-0'}/>
                    <Date className={'fb-4 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={'از تاریخ'} value={state.fields?.startDate} onChange={this.setField.bind(this, 'startDate')}/>
                    <Date className={'fb-4 fb-5x-6 fb-4x-10 fb-2x-20 pad-4'} label={`تا تاریخ`} value={state.fields?.endDate} onChange={this.setField.bind(this, 'endDate')}/>
                </div>
                <div className={'charts dis-f'}>
                    <div className={`line-chart fb-20 pad-h-4 pad-v-20 ${state.inventoryDayDetailChart.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>جزئیات مربوط به فرآورده‌های بیمارستان</h3>
                        <Line data={state.inventoryDayDetailChart}
                              width={'100%'}
                              height={'40%'}/>
                    </div>
                </div>
                <div className={'dis-f'}>
                    <Select className={'fb-6 fb-5x-6 fb-4x-10 fb-2x-20 fb-2x-20 pad-4'} label={'نام بیمارستان'} options={state.hospitals} value={state.fields?.hospitalId} onChange={this.setField.bind(this, 'hospitalId')}/>
                    <Select className={'fb-3 fb-5x-4 fb-4x-10 fb-2x-20 fb-2x-20 pad-4'} label={'وضعیت فرآورده'} options={state.productStates} value={state.fields?.productState} onChange={this.setField.bind(this, 'productState')}/>
                    <Date className={'fb-4 fb-5x-5 fb-4x-10 fb-2x-20 pad-4'} label={'از تاریخ'} value={state.fields?.startDate} onChange={this.setField.bind(this, 'startDate')}/>
                    <Date className={'fb-4 fb-5x-5 fb-4x-10 fb-2x-20 pad-4'} label={`تا تاریخ`} value={state.fields?.endDate} onChange={this.setField.bind(this, 'endDate')}/>
                </div>
                <div className={'charts dis-f'}>
                    <div className={`line-chart fb-13 fb-5x-20 pad-h-4 pad-v-20 ${state.productBloodGroupDayDetailChart2.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>آمار کل به تفکیک گروه خونی</h3>
                        <Line data={state.productBloodGroupDayDetailChart2}
                              width={'100%'}
                              height={'55%'}/>
                    </div>
                    <div className={`polar-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.productBloodGroupDayDetailChart1.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>آمار کل به تفکیک گروه خونی</h3>
                        <Polar data={state.productBloodGroupDayDetailChart1}
                               width={'100%'}
                               height={'100%'}/>
                    </div>
                    <div className={`polar-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.productTypeDayDetailChart1.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>آمار کل به تفکیک نوع فرآورده</h3>
                        <Polar data={state.productTypeDayDetailChart1}
                               width={'100%'}
                               height={'100%'}/>
                    </div>
                    <div className={`line-chart fb-13 fb-5x-20 fb-3x-20 pad-h-4 pad-v-20 ${state.productTypeDayDetailChart2.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>آمار کل به تفکیک نوع فرآورده</h3>
                        <Line data={state.productTypeDayDetailChart2}
                              width={'100%'}
                              height={'55%'}/>
                    </div>
                    <div className={`radar-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.productDayDetailChart1.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>گروه خونی / نوع فرآورده</h3>
                        <Radar data={state.productDayDetailChart1}
                               width={'100%'}
                               height={'100%'}/>
                    </div>
                    <div className={`radar-chart fb-7 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.productDayDetailChart2.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>نوع فرآورده / گروه خونی</h3>
                        <Radar data={state.productDayDetailChart2}
                               width={'100%'}
                               height={'100%'}/>
                    </div>
                    <div className={`pie-chart fb-6 fb-5x-10 fb-3x-20 pad-h-4 pad-v-20 ${state.productSignChart.labels.length ? '' : 'background'}`}>
                        <h3 className={'chart-title'}>آمار کل به تفکیک علامت</h3>
                        <Pie data={state.productSignChart}
                             width={'100%'}
                             height={'100%'}/>
                    </div>
                </div>
            </GroupTabContent>
            <ModalHospitalInventoryList refer={this.ref.modalHospitalInventoryList}/>
        </Group>;
    }

    basicStatisticsGridReadyHandler(params) {
        this.setState({basicStatisticsGridContext: params});

        params.api.sizeColumnsToFit();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        let flag;
        switch (keys[0]) {
            case 'startDate':
            case 'endDate':
                flag = currentFields[keys[0]] && value && (currentFields[keys[0]].format() === value.format());

                if (!flag) {
                    this.updateBasicCharts({...this.state, fields: nextFields});
                    this.updateDayDetailCharts({...this.state, fields: nextFields});
                }
                break;
            case 'hospitalId':
                flag = currentFields[keys[0]] && (currentFields[keys[0]][0].id === value[0].id);

                if (!flag) {
                    delete nextFields['productTypeId'];
                    delete nextFields['bloodGroupId'];
                    this.updateHospitalInventoryTable({...this.state, fields: nextFields});
                    this.updateDayDetailCharts({...this.state, fields: nextFields});
                }
                break;
            case 'productState':
                this.updateDayDetailCharts({...this.state, fields: nextFields}, true);
                break;
            default:
        }
    }

    labelValueTableCellClickHandler(data) {
        const {state} = this;
        const hospitalId = (state.fields?.hospitalId || [])[0]?.id;

        if (data?.inventory) {
            this.ref.modalHospitalInventoryList.current.open({bloodGroupId: data?.bloodGroupId, productTypeId: data?.productTypeId, hospitalId}, 'MANAGEMENT_INVENTORY');
        }
    }

    searchProductsGridReadyHandler(params) {
        params.api.setServerSideDatasource({
            getRows: function (params) {
                console.log('[Datasource] - rows requested by grid: ', params.request);
                MDashboard.hospitalInventoryList(params.request)
                    .then(list => {
                        params.successCallback(list);
                    })
                    .catch(message => {
                        params.failCallback();
                    });
            }
        });

        this.setState({searchProductsGridContext: params});

        params.api.sizeColumnsToFit();
    }

    tabChangeHandler(id) {
    }

    updateBasicCharts(state = {...this.state}) {
        MDashboard.basicStatistic({
            startDate: state.fields?.startDate?.format(),
            endDate: state.fields?.endDate.format()
        })
            .then(data => {
                const rows = [];
                const startCol = [];
                const headerRow = [
                    {value: 'فرآورده‌های عارضه داده'},
                    {value: 'فرآورده‌های استفاده شده'},
                    {value: 'فرآورده‌های امحا شده'},
                    {value: 'فرآورده‌های ورودی'},
                    {value: 'فرآورده‌های عودتی بخش'},
                    {value: 'فرآورده‌های عودتی بیمارستان'},
                    {value: 'فرآورده‌های قابل استفاده'},
                    {value: 'کل موجودی'},
                    {value: 'فرآورده‌های آماده'},
                    {value: 'فرآورده‌های رزرو شده'}
                ];
                state.basicInventoryChart.datasets[0].data = [];
                state.basicInventoryChart.labels = [];
                state.basicReservedChart.datasets[0].data = [];
                state.basicReservedChart.labels = [];
                state.basicReadyChart.datasets[0].data = [];
                state.basicReadyChart.labels = [];
                state.basicConsumableChart.datasets[0].data = [];
                state.basicConsumableChart.labels = [];
                state.basicReturnToOrgChart.datasets[0].data = [];
                state.basicReturnToOrgChart.labels = [];
                state.basicReturnToBankChart.datasets[0].data = [];
                state.basicReturnToBankChart.labels = [];
                state.basicEntryChart.datasets[0].data = [];
                state.basicEntryChart.labels = [];
                state.basicDestroyedChart.datasets[0].data = [];
                state.basicDestroyedChart.labels = [];

                for (let item of data) {
                    startCol.push({
                        value: item.hospitalShortName,
                        data: item
                    });

                    rows.push([
                        {value: item.complicateProducts, data: item},
                        {value: item.counsumableProducts, data: item},
                        {value: item.destroyedProducts, data: item},
                        {value: item.entryProducts, data: item},
                        {value: item.returnToBloodBankProducts, data: item},
                        {value: item.returnToOrgProducts, data: item},
                        {value: item.totalConsumableProducts, data: item},
                        {value: item.totalInventory, data: item},
                        {value: item.totalReadyProducts, data: item},
                        {value: item.totalReservedProducts, data: item},
                    ]);

                    if (item.totalInventory) {
                        state.basicInventoryChart.labels.push(item.hospitalShortName);
                        state.basicInventoryChart.datasets[0].data.push(item.totalInventory);
                    }

                    if (item.totalReservedProducts) {
                        state.basicReservedChart.labels.push(item.hospitalShortName);
                        state.basicReservedChart.datasets[0].data.push(item.totalReservedProducts);
                    }

                    if (item.totalReadyProducts) {
                        state.basicReadyChart.labels.push(item.hospitalShortName);
                        state.basicReadyChart.datasets[0].data.push(item.totalReadyProducts);
                    }

                    if (item.totalConsumableProducts) {
                        state.basicConsumableChart.labels.push(item.hospitalShortName);
                        state.basicConsumableChart.datasets[0].data.push(item.totalConsumableProducts);
                    }

                    if (item.returnToOrgProducts) {
                        state.basicReturnToOrgChart.labels.push(item.hospitalShortName);
                        state.basicReturnToOrgChart.datasets[0].data.push(item.returnToOrgProducts);
                    }

                    if (item.returnToBloodBankProducts) {
                        state.basicReturnToBankChart.labels.push(item.hospitalShortName);
                        state.basicReturnToBankChart.datasets[0].data.push(item.returnToBloodBankProducts);
                    }

                    if (item.entryProducts) {
                        state.basicEntryChart.labels.push(item.hospitalShortName);
                        state.basicEntryChart.datasets[0].data.push(item.entryProducts);
                    }

                    if (item.destroyedProducts) {
                        state.basicDestroyedChart.labels.push(item.hospitalShortName);
                        state.basicDestroyedChart.datasets[0].data.push(item.destroyedProducts);
                    }
                }

                this.setState({
                    ...state,
                    basicStatistics: data,
                    basicStatisticsTable: {rows, headerRow, startCol}
                });
            })
            .catch(message => {
                new Notif({message, theme: 'error'}).show();
            });
    }

    updateDayDetailCharts(state = {...this.state}, onlySecondPart = false) {
        if (state.fields?.hospitalId && state.fields?.hospitalId[0]?.id) {
            if (!onlySecondPart) {
                MDashboard.basicStatisticDayDetail({
                    hospitalId: state.fields?.hospitalId[0]?.id,
                    startDate: state.fields?.startDate.format(),
                    endDate: state.fields?.endDate.format()
                })
                    .then(list => {
                        state.inventoryDayDetailChart.datasets[0].data = [];
                        state.inventoryDayDetailChart.datasets[1].data = [];
                        state.inventoryDayDetailChart.datasets[2].data = [];
                        state.inventoryDayDetailChart.datasets[3].data = [];
                        state.inventoryDayDetailChart.datasets[4].data = [];
                        state.inventoryDayDetailChart.labels = [];

                        for (let item of list) {
                            state.inventoryDayDetailChart.labels.push(moment(item.date).format('jYY/jMM/jDD'));
                            state.inventoryDayDetailChart.datasets[0].data.push(item.complicated);
                            state.inventoryDayDetailChart.datasets[1].data.push(item.consumption);
                            state.inventoryDayDetailChart.datasets[2].data.push(item.crossMatched);
                            state.inventoryDayDetailChart.datasets[3].data.push(item.entry);
                            state.inventoryDayDetailChart.datasets[4].data.push(item.reserved);
                        }

                        this.setState({
                            inventoryDayDetailChart: {...state.inventoryDayDetailChart}
                        });
                    })
                    .catch(message => {
                        new Notif({message, theme: 'error'}).show();
                    });
            }
            if (state.fields?.productState && state.fields?.productState[0]?.id) {
                MDashboard.hospitalInventoryDayDetailList({
                    hospitalId: state.fields?.hospitalId[0]?.id,
                    command: state.fields?.productState[0]?.id,
                    startDate: state.fields?.startDate.format(),
                    endDate: state.fields?.endDate.format()
                })
                    .then(list => {
                        const bloodGroups = {};
                        const productTypes = {};
                        const bloodGroupDayDetail = {};
                        const productTypeDayDetail = {};
                        const bloodGroupCountDetail = {};
                        const productTypeCountDetail = {};

                        for (let item of list) {
                            const date = moment(item.createDateTime).format('jYY/jMM/jDD');

                            if (!bloodGroups[item.bloodGroupId]) {
                                bloodGroups[item.bloodGroupId] = {id: item.bloodGroupId, name: item.bloodGroupStr, count: 0};
                                bloodGroupCountDetail[item.bloodGroupId] = {};
                            }

                            if (!productTypes[item.productTypeId]) {
                                productTypes[item.productTypeId] = {id: item.productTypeId, name: item.productTypeStr, count: 0};
                                productTypeCountDetail[item.productTypeId] = {};
                            }

                            if (!bloodGroupCountDetail[item.bloodGroupId][item.productTypeId]) {
                                bloodGroupCountDetail[item.bloodGroupId][item.productTypeId] = {id: item.productTypeId, name: item.productTypeStr, count: 0};
                            }

                            if (!productTypeCountDetail[item.productTypeId][item.bloodGroupId]) {
                                productTypeCountDetail[item.productTypeId][item.bloodGroupId] = {id: item.bloodGroupId, name: item.bloodGroupStr, count: 0};
                            }

                            if (!bloodGroupDayDetail[date]) {
                                bloodGroupDayDetail[date] = {};
                                productTypeDayDetail[date] = {};
                            }

                            if (!bloodGroupDayDetail[date][item.bloodGroupId]) {
                                bloodGroupDayDetail[date][item.bloodGroupId] = {id: item.bloodGroupId, name: item.bloodGroupStr, count: 0};
                            }

                            if (!productTypeDayDetail[date][item.productTypeId]) {
                                productTypeDayDetail[date][item.productTypeId] = {id: item.productTypeId, name: item.productTypeStr, count: 0};
                            }

                            bloodGroups[item.bloodGroupId].count += 1;
                            productTypes[item.productTypeId].count += 1;
                            bloodGroupCountDetail[item.bloodGroupId][item.productTypeId].count += 1;
                            productTypeCountDetail[item.productTypeId][item.bloodGroupId].count += 1;
                            bloodGroupDayDetail[date][item.bloodGroupId].count += 1;
                            productTypeDayDetail[date][item.productTypeId].count += 1;
                        }

                        const productTypesAr = Object.values(productTypes);
                        const bloodGroupsAr = Object.values(bloodGroups);

                        state.productDayDetailChart1.labels = productTypesAr.map(item => item.name);
                        state.productDayDetailChart1.datasets = bloodGroupsAr.map((blo, index) => {
                            return {
                                label: blo.name,
                                data: productTypesAr.map(pro => productTypeCountDetail[pro.id][blo.id]?.count || 0),
                                borderColor: state.colors[index],
                                backgroundColor: state.transparentColors[index],
                            };
                        });

                        state.productDayDetailChart2.labels = bloodGroupsAr.map(item => item.name);
                        state.productDayDetailChart2.datasets = productTypesAr.map((pro, index) => {
                            return {
                                label: pro.name,
                                data: bloodGroupsAr.map(blo => bloodGroupCountDetail[blo.id][pro.id]?.count || 0),
                                borderColor: state.colors[index],
                                backgroundColor: state.transparentColors[index],
                            };
                        });

                        state.productBloodGroupDayDetailChart1.labels = bloodGroupsAr.map(item => item.name);
                        state.productBloodGroupDayDetailChart1.datasets[0].data = bloodGroupsAr.map(item => item.count);

                        state.productTypeDayDetailChart1.labels = productTypesAr.map(item => item.name);
                        state.productTypeDayDetailChart1.datasets[0].data = productTypesAr.map(item => item.count);

                        let tDate = state.fields?.startDate.clone();
                        state.productBloodGroupDayDetailChart2.labels = [];
                        state.productTypeDayDetailChart2.labels = [];
                        state.productBloodGroupDayDetailChart2.datasets = bloodGroupsAr.map((blo, index) => {
                            return {
                                label: blo.name,
                                data: [],
                                borderColor: state.colors[index],
                                fill: false
                            };
                        });
                        state.productTypeDayDetailChart2.datasets = productTypesAr.map((pro, index) => {
                            return {
                                label: pro.name,
                                data: [],
                                borderColor: state.colors[index],
                                fill: false
                            };
                        });
                        while (state.fields?.endDate.isSameOrAfter(tDate, 'jday')) {
                            const date = tDate.format('jYY/jMM/jDD');
                            state.productBloodGroupDayDetailChart2.labels.push(date);
                            state.productTypeDayDetailChart2.labels.push(date);
                            bloodGroupsAr.map((blo, index) => {
                                state.productBloodGroupDayDetailChart2.datasets[index].data.push((bloodGroupDayDetail[date] || [])[blo.id]?.count || 0);
                                return null;
                            });
                            productTypesAr.map((pro, index) => {
                                state.productTypeDayDetailChart2.datasets[index].data.push((productTypeDayDetail[date] || [])[pro.id]?.count || 0);
                                return null;
                            });
                            tDate.add(1, 'jday');
                        }

                        const pos = [1, 2, 3, 4]; // positive bloodGroups
                        state.productSignChart.labels = ['گروه خون مثبت', 'گروه خون منفی'];
                        state.productSignChart.datasets[0].data = [
                            bloodGroupsAr.reduce((sum, item) => pos.includes(item.id) ? sum + item.count : sum, 0),
                            bloodGroupsAr.reduce((sum, item) => !pos.includes(item.id) ? sum + item.count : sum, 0)
                        ];

                        this.setState({...state});
                        console.log({state, list, bloodGroups, productTypes, bloodGroupDayDetail, productTypeDayDetail, bloodGroupCountDetail, productTypeCountDetail});
                    })
                    .catch(message => {
                        new Notif({message, theme: 'error'}).show();
                    });
            } else {
                this.setState({});
            }
        } else {
            this.setState({});
        }
    }

    updateHospitalInventoryTable(state = {...this.state}) {
        if (state.fields?.hospitalId && state.fields?.hospitalId[0]?.id) {
            MDashboard.hospitalInventory({
                hospitalId: state.fields?.hospitalId[0]?.id
            })
                .then(data => {
                    const headerRow = data.productTypes.map(item => {
                        return {
                            value: item.shortName,
                            data: item
                        };
                    });
                    const startCol = data.bloodGroups.map(item => {
                        return {
                            value: item.name,
                            data: item
                        };
                    });
                    const rows = data.bloodGroupList.map(bloodGroup => bloodGroup.map(item => {
                        return {
                            value: item.inventory,
                            data: item
                        };
                    }));
                    this.setState({hospitalInventoryTable: {...data, headerRow, startCol, rows}});
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();
                });
        } else {
            this.setState({
                hospitalInventoryTable: {
                    raw: [],
                    bloodGroups: [],
                    productTypes: [],
                    bloodGroupList: [],
                    productTypeList: []
                }
            });
        }
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ManagementDashboard);